import { connect } from 'react-redux';
import {
  createANewJob,
  navigateBack,
  navigateNext,
  postAdditionalPreferences,
  setShowErrors,
  unSetJobCreationMode,
} from '../../../../app/job-creation/job-creation.actions';
import { selectAllJobs } from '../../../../app/job-selection/jobs.selection';
import { JobCreationModal } from './job-creation-modal';

const mapStateToProps = state => {
  return {
    currentPage: state.jobCreation.currentPage,
    lastPage: state.jobCreation.lastPage,
    jobStatus: state.jobCreation.jobStatus,
    jobConfig: state.jobCreation,
    currentUser: state.auth.currentUser,
    jobs: selectAllJobs(state),
    enableJobCreation: state.jobCreation.enableJobCreation,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleNavigateNext: (currentPage, jobConfig) => {
      dispatch(navigateNext(currentPage, jobConfig));
    },
    handleNavigateBack: () => {
      dispatch(navigateBack());
    },
    handleJobCreationClick: () => {
      dispatch(createANewJob());
    },
    handleSaveChangesClick: id => {
      dispatch(postAdditionalPreferences(id));
    },
    handleSkipClick: () => {
      dispatch(unSetJobCreationMode());
    },
    showValidationError: () => {
      dispatch(setShowErrors());
    },
  };
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(JobCreationModal);
export { connected as JobCreationModalContainer };
